// Single source of truth for the API base URL.
// - In Emergent preview: REACT_APP_BACKEND_URL is the preview URL, ingress routes /api → backend.
// - In Hostinger production: set REACT_APP_BACKEND_URL=https://api.iaestetica.es (or your backend domain)
//   before running `yarn build`, and the static frontend will hit that absolute URL.
// - If empty: falls back to a relative /api (only useful when frontend & backend share host).
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND ? `${BACKEND}/api` : "/api";
